function Stats(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path xmlns="http://www.w3.org/2000/svg" d="M13.7501 16.6666V11.7468H16.6667V16.6666H13.7501ZM8.95842 16.6666V4.16663H11.8751V16.6666H8.95842ZM4.16675 16.6666V8.25329H7.08341V16.6666H4.16675Z"/>
    </svg>
  );
}

export default Stats;